import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const LinkHome = () => {
  const { t } = useTranslation();
  return <Link to="/">{t("footer.titleLink")}</Link>;
};

export default LinkHome;
